import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Card, CardContent } from '@material-ui/core';
import {
  ScreenContainer, CommonPagination, CommonSearch,
} from '../../CommonComponents';
import BuyerUserTable from './BuyerUserTable';
import CommonButton from '../../CommonComponents/CommonButton';
import DashUserCreation from '../../CommonComponents/DashUserCreation';
import { getAllStates } from '../../redux/actions/common';
import FallbackCard from '../../CommonComponents/FallbackCard';
import { createDashUser, getBuyers, showUserForm } from '../../redux/actions/dashusers';
import { userTypes } from '../../Utils/constants';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Buyer = ({
  states,
  getUsers,
  getStates,
  showForm,
  userForm,
  totalDashBuyerPages,
  createDUser,
}) => {
  const [state, setState] = useState(null)

  const query = useQuery();
  const page = parseInt(query.get('page') || '1', 10);

  useEffect(() => {
    if (state) {
      getUsers(page, state.value);
    } else {
      getStates();
    }
  }, [getStates, page, state, getUsers]);

  const handleChange = (val) => {
    setState(val)
  }

  const createUser = (fields) => {
    const data = { ...fields }
    data.depended_field = state.value
    data.userType = userTypes.buyer
    createDUser(data);
  }

  return (
    <ScreenContainer title="Buyer Users">
      <Card>
        <CardContent>
          <div className="row">
            <div className="col-9">
              <CommonSearch label="States" value={state} data={states} onChange={handleChange} />
            </div>
            {state
              ? (
                <div className="col-3 text-right">
                  <CommonButton
                    variant="outlined"
                    color="primary"
                    onClick={() => showForm(true)}
                  >
                    <b>Add Buyer</b>
                  </CommonButton>
                </div>
              ) : null }
          </div>
        </CardContent>
      </Card>
      <br />
      {state
        ? <BuyerUserTable />
        : <FallbackCard text="No data found" /> }
      {totalDashBuyerPages > 1 ? (
        <CommonPagination
          baseUrl="buyers"
          totalPages={totalDashBuyerPages}
        />
      ) : null}
      {(userForm && state)
        ? (
          <DashUserCreation
            userType="buyer"
            setModal={showForm}
            createUser={createUser}
            title={`State :- ${state.value}`}
          />
        )
        : null}
    </ScreenContainer>
  );
}

const mapState = (state) => ({
  states: state.common.states,
  userForm: state.dashusers.showUserForm,
  totalDashBuyerPages: state.dashusers.totalDashBuyerPages,
});

const mapActions = {
  getStates: getAllStates,
  getUsers: getBuyers,
  showForm: showUserForm,
  createDUser: createDashUser,
};

export default connect(mapState, mapActions)(Buyer);
